import React from 'react';
import {TagsInputsViewViewModel} from './TagsInputsViewViewModel';
import TextField from '@material-ui/core/TextField';
import '../views/css/Tags.scss';

class TagsInputs extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    handleChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        const trimmedValue = String(value).trim();

        this.setState(
            {
                [name]: trimmedValue,
            },
            () => {
                let data = this.state;
                this.props.handleDisable(data);
            }
        );
    }

    postRequest() {
        const modalType = this.props.modalType === 'edit';
        const getToken = localStorage.getItem('token');

        const data = this.state;
        const id = data.id;
        const requestType = modalType ? 'PUT' : 'POST';
        const endpointType = modalType ? `put/` + id : `post`;

        const requestOptions = {
            method: requestType,
            mode: 'cors',
            headers: {
                Authorization: 'Bearer ' + getToken,
            },
            body: JSON.stringify(data),
        };
        fetch(`./wp-json/asd/tag/configs/${endpointType}`, requestOptions)
            .then(response => response.json())
            .then(responseMessage => {
                if (responseMessage.hasOwnProperty('code')) {
                    this.props.handleErrorMsg(responseMessage.message);
                } else {
                    this.props.saveRequest();
                    this.props.handleErrorMsg('');
                    this.props.handleCloseModal();
                }
            });
    }

    componentDidMount() {
        if (this.props.modalType === 'edit') {
            const rowObj = this.props.row;
            this.setState(rowObj, () => {
                let data = this.state;
                this.props.handleDisable(data);
            });

            this.props.handleDisable(rowObj);
        } else {
            this.setState({});
        }
    }

    render() {
        const TagsInputsViewModel = new TagsInputsViewViewModel(this.props, this.state);
        const requiredTextFields = TagsInputsViewModel.requiredFields();
        const optionalTextFields = TagsInputsViewModel.optionalFields();
        const saveBtn = (
            <button
                className="tags-save-button"
                disabled={this.props.isDisabled}
                variant="contained"
                onClick={() => this.postRequest()}
            >
                SAVE
            </button>
        );
        return (
            <React.Fragment>
                <div className="tags-inputs">
                    {requiredTextFields.map((obj, i) => {
                        return (
                            <div key={i}>
                                <TextField
                                    required
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="outlined-required"
                                    className={obj.className}
                                    label={obj.label}
                                    name={obj.id}
                                    value={obj.value}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </div>
                        );
                    })}
                    {optionalTextFields.map((obj, i) => {
                        return (
                            <div key={i}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    className={obj.className}
                                    label={obj.label}
                                    name={obj.id}
                                    value={obj.value}
                                    onChange={this.handleChange.bind(this)}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className="tags-modal-buttons">
                    <span>{saveBtn}</span>
                    <span>{this.props.cancelBtn}</span>
                </div>
                <div className="tags-required-message">
                    <p className="required-message">
                        <span className="required-asterisk">*</span>Indicates a required field
                    </p>
                </div>
            </React.Fragment>
        );
    }
}

export default TagsInputs;
